// extracted by mini-css-extract-plugin
export default {"info":"LoginPage_info__rqYqZ","link":"LoginPage_link__GqGiL","loginEmailSent":"LoginPage_loginEmailSent__SCHoR"};